import { Headline, HtmlContainer } from '@n2-common/ui';
import { N2ApplicationStatus } from '@n2-common/serverGeneratedTypings/n2ApplicationStatus';
import { ApplicationStatusPage, CommonStatusPageProps } from '@n2-common/components/ApplicationStatusPage';
import { useTranslation } from 'react-i18next';
import { useApplicationIdContext } from '@n2-common/components/ApplicationContext';
import { translationNamepaceFromProduct } from '../applicationStatusHelpers';

const CanceledPage = ({ navigateToCorrectStepFunc }: CommonStatusPageProps): JSX.Element => {
    const {  productType } = useApplicationIdContext();

    const translationNameSpace = translationNamepaceFromProduct(productType);
    
    const { t } = useTranslation(translationNameSpace);

    return (
        <ApplicationStatusPage
            correctStateFunc={(res) => res.Status === N2ApplicationStatus.Cancelled}
            navigateToCorrectStepFunc={navigateToCorrectStepFunc}
        >
            <Headline>{t<string>('ApplicationLandingPages.Canceled.Headline')}</Headline>
            <Headline level={3}>{t<string>('ApplicationLandingPages.Canceled.SubHeadline')}</Headline>
            <HtmlContainer innerHtml={t<string>('ApplicationLandingPages.Canceled.Body', '')} />
        </ApplicationStatusPage>
    );
};

export default CanceledPage;
